import pay from "@/../CsdPublic/pay";
import { ref, computed, reactive, Reactive } from "vue";
import { ElMessage } from "element-plus";
import {
  showVIPDialogue,
  showPayCodeDialogue,
} from "@/components/Dialogues/useData/useDialogues";
import publicStore from "@/store/publicStore";

const productInfo: Reactive<any[]> = reactive([]);
const payInfo = ref({});

const productIndex = ref(0);

const productItem = computed(() => {
  if (!productInfo.length) {
    return null;
  }
  return productInfo[productIndex.value];
});

const requestProduct = async () => {
  try {
    // 获取套餐
    const packageList = (await pay.getPackageList()) as any[];
    console.log("packageList", packageList);
    productInfo.splice(0, packageList.length);
    productInfo.push(...packageList.reverse());
    // const plan_type = packageList[0].validity_type;
    // const goods_id = packageList[0].id;
    // // 获取支付二维码
    // const payData = await pay.getPayCode(plan_type, goods_id);
    // const order_id = payData.order_id;
    // 若是手机登录支付，需跳转到${config.wxLoginAndPayDomain}/api/show-order 页面，记得携带参数 ekey\soft_id
    // 支付轮询
    // await pay.payPoll(order_id);
  } catch (e: any) {
    console.log(e.msg);
  }
};

const requestPayInfo = async () => {
  const goods_id = productItem.value.id;
  if (!goods_id) {
    ElMessage.warning("商品不存在");
    return null;
  }

  try {
    const payData = await pay.getPayCode(0, goods_id);
    console.log("payData", payData);
    payInfo.value = payData;
    return payData;
  } catch (e: any) {
    console.log("payData e", e);

    return e;
  }
};

const startPoll = async () => {
  try {
    const oID = (payInfo.value as any).order_id;
    const ret = await pay.payPoll(oID);
    const { status, msg } = ret;
    if (status === 1) {
      ElMessage.success(msg);

      const store = publicStore();
      await store.changeVipInfo();

      showPayCodeDialogue.value = false;
      showVIPDialogue.value = false;
      stopPoll();
    } else {
      ElMessage.error(msg);
    }
    console.log("ret", ret);
  } catch (e: any) {
    console.log("error", e);
  }
};

const stopPoll = () => {
  pay.stopInterval();
};

export {
  payInfo,
  requestPayInfo,
  requestProduct,
  productInfo,
  productIndex,
  productItem,
  startPoll,
  stopPoll,
};
